import './NoSearchResults.scss';

export const NoSearchResults = () => {
  return (
    <div className="NoSearchResults">
      <p className="NoSearchResults__message">
        Now search results...
      </p>
    </div>
  );
};
